module.exports = __webpack_public_path__ + "media/images/athletes/2400-bb471690b766aa8a0a5fa2f138de9d48.png";